/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const IPropTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  keyword: PropTypes.string,
  image: PropTypes.string,
};

const defaultProps = {
  title: 'Productos de Calidad en Carlos Gutiérrez S.A',
  description: 'Explora nuestra amplia selección de productos en Carlos Gutiérrez S.A, donde encontrarás todo lo que necesitas, desde artículos esenciales hasta opciones exclusivas. Con una variedad de categorías y marcas para elegir, nuestra tienda online ofrece productos de alta calidad y al mejor precio. Navega por nuestras ofertas y novedades para descubrir lo que se adapta a tu estilo y necesidades. Disfruta de una experiencia de compra fácil, segura y conveniente. ¡Haz tu pedido hoy y aprovecha todas las ventajas de comprar en Carlos Gutiérrez S.A!',
  type: 'website',
  keyword: '',
  image: 'https://www.carlosgutierrez.com.uy/open-graph.png',
};

const SEO = function ({
  title,
  description,
  type,
  keyword,
  image,
}) {
  const keywords = `electrodomésticos, electrodomesticos, panavox, tv, lcd, led, 
  aire, computadora, notebook, netbook, cpu, pc, radio, componente,  dvd, video, 
  juegos, refrigerador, freezer, lavarropa, Lavavajilla, Secarropa, calefon,
  horno, micro, monitor, software, cocina, celular, jardin, camara, aspiradora,
  estufa, purificador, On-Line, ${keyword}`;
  const newTitle = title === 'Productos de Calidad en Carlos Gutiérrez S.A' ? title : `${title} | Carlos Gutiérrez S.A`;
  return (
    <Helmet>
      { /* Standard metadata tags */ }
      <title>{newTitle}</title>
      <meta name="google-site-verification" content="czvyXErXNcyJRaFiJ4ryIPsPhkcCw0j4O7jlkUyeUWw" />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={newTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={window.location.href} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

SEO.propTypes = IPropTypes;
SEO.defaultProps = defaultProps;

export { SEO };



// WEBPACK FOOTER //
// ./src/common/seo/Seo.jsx